export const companyDocTypeConstants = {
  COMPANY_DOC_TYPE_CREATE_LOADING: 'COMPANY_DOC_TYPE_CREATE_LOADING',
  COMPANY_DOC_TYPE_CREATE_SUCCESS: 'COMPANY_DOC_TYPE_CREATE_SUCCESS',
  COMPANY_DOC_TYPE_CREATE_FAILURE: 'COMPANY_DOC_TYPE_CREATE_FAILURE',
  COMPANY_DOC_TYPE_ERROR_RELOAD: 'COMPANY_DOC_TYPE_ERROR_RELOAD',

  COMPANY_DOC_TYPE_LIST_LOADING: 'COMPANY_DOC_TYPE_LIST_LOADING',
  COMPANY_DOC_TYPE_LIST_SUCCESS: 'COMPANY_DOC_TYPE_LIST_SUCCESS',
  COMPANY_DOC_TYPE_LIST_FAILURE: 'COMPANY_DOC_TYPE_LIST_FAILURE',

  COMPANY_DOC_TYPE_EDIT_LOADING: 'COMPANY_DOC_TYPE_EDIT_LOADING',
  COMPANY_DOC_TYPE_EDIT_SUCCESS: 'COMPANY_DOC_TYPE_EDIT_SUCCESS',
  COMPANY_DOC_TYPE_EDIT_FAILURE: 'COMPANY_DOC_TYPE_EDIT_FAILURE',

  COMPANY_DOC_TYPE_DELETE_LOADING: 'COMPANY_DOC_TYPE_DELETE_LOADING',
  COMPANY_DOC_TYPE_DELETE_SUCCESS: 'COMPANY_DOC_TYPE_DELETE_SUCCESS',
  COMPANY_DOC_TYPE_DELETE_FAILURE: 'COMPANY_DOC_TYPE_DELETE_FAILURE'
};
